@if (globals.isLoading) {
  <div class="loader">
    <span class="loader-animation"></span>
  </div>
}

@if (globals.isLoggedIn) {
  <app-header></app-header>
}
@if (
  !globals.isLoggedIn && (isCredentialRegistryPage() || isSignUpTandCPage())
  ) {
  <app-registry-header
  ></app-registry-header>
}
<div
  id="container"
  class="overflow-hidden"
  [ngClass]="{
    inner_content_block:
      globals.isLoggedIn || isCredentialRegistryPage() || isSignUpTandCPage(),
    without_login_content:
      !globals.isLoggedIn &&
      (isCredentialRegistryPage() || isSignUpTandCPage()),
  }"
  >
  <router-outlet></router-outlet>
</div>
@if (
  globals.isLoggedIn || isCredentialRegistryPage() || isSignUpTandCPage()
  ) {
  <app-footer
  ></app-footer>
}
